import request from '@/services/request'
import { getApiUrl } from '@/utils/tool'

export function page(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/common/get-page',
    method: 'post',
    data: object,
    customConfig: {
      noLoading: true
    }
  })
}
